<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.taxes') }} > {{ $t('sidebar.create') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <section class="choose-type">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.selecttype')"/>
            <div class="row wrapper">
              <div class="col-md-4">
                <div class="row">
                  <div class="col-12">
                    <vs-radio
                      v-model="form.formType"
                      :vsValue="TAX_FORM_TYPE.TAX"
                      color="#A3CA76"
                      style="float: left;padding: 0;">
                      <strong>
                        {{ $t('apps.product.message.typetax') }}
                      </strong>
                    </vs-radio>
                  </div>
                  <div
                    class="form-check-label"
                    style="margin-left: 25px;">
                    <p>
                      {{ $t('apps.product.message.typetaxdetail') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row">
                  <div class="col-12">
                    <vs-radio
                      v-model="form.formType"
                      :vsValue="TAX_FORM_TYPE.SERVICE_CHARGE"
                      color="#A3CA76"
                      style="float: left;padding: 0;">
                      <strong>
                        {{ $t('apps.product.message.typeservicecharge') }}
                      </strong>
                    </vs-radio>
                  </div>
                  <div
                    class="form-check-label"
                    style="margin-left: 25px;">
                    <p>
                      {{ $t('apps.product.message.typeservicechargedetail') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row">
                  <div class="col-12">
                    <vs-radio
                      v-model="form.formType"
                      :vsValue="TAX_FORM_TYPE.FEE"
                      color="#A3CA76"
                      style="float: left;padding: 0;">
                      <strong>
                        {{ $t('apps.product.message.typefee') }}
                      </strong>
                    </vs-radio>
                  </div>
                  <div
                    class="form-check-label"
                    style="margin-left: 25px;">
                    <p>
                      {{ $t('apps.product.message.typefeedetail') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.general')"/>
            <div class="form-row">
              <div class="col-md-6 mb-mobile-2">
                <div class="form-group row mb-0">
                  <div class="col-md-12">
                    <label>{{ $t('message.tax_name') }} *</label>
                    <input
                      ref="tax_name"
                      :class="['form-control tax-name', { 'is-invalid': $v.form.tax_name.$error }]"
                      v-model="$v.form.tax_name.$model"
                      type="text">
                  </div>
                </div>
              </div>
              <div
                v-if="[TAX_FORM_TYPE.TAX].includes(form.formType)"
                class="col-md-6">
                <div class="form-group row mb-0">
                  <div class="col-md-12">
                    <label>{{ $t('message.tax_amount') }} *</label>
                    <div class="input-group">
                      <input
                        ref="amount"
                        v-model="form.amount"
                        type="text"
                        class="form-control text-right number-only text-select-all"
                        style="border-right: 0;"
                        @keypress="numberOnly"
                        @keyup="form.amount = setToValidNumber(form.amount)">
                      <div class="input-group-prepend">
                        <button
                          class="btn dropdown-toggle"
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          style="border: 1px solid #ced4da;">
                          <template v-if="form.type == 'exclude'">
                            {{ $t('message.tax_exclude') }}
                          </template>
                          <template v-if="form.type == 'include'">
                            {{ $t('message.tax_include') }}
                          </template>
                        </button>
                        <div class="dropdown-menu">
                          <a
                            class="dropdown-item"
                            @click="form.type = 'exclude'">{{ $t('message.tax_exclude') }}</a>
                          <a
                            class="dropdown-item"
                            @click="form.type = 'include'">{{ $t('message.tax_include') }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="col-md-6">
                <div class="form-group row mb-0">
                  <div class="col-md-12">
                    <label>{{ $t('message.tax_amount') }} *</label>
                    <div>
                      <input
                        ref="amount"
                        v-model="form.amount"
                        type="text"
                        class="form-control text-right number-only text-select-all"
                        @keypress="numberOnly"
                        @keyup="form.amount = setToValidNumber(form.amount)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="[TAX_FORM_TYPE.FEE].includes(form.formType)"
              class="row mt-3"
            >
              <div class="col-6">
                <label>
                  {{ $t('apps.product.message.calculatedfrom') }} *
                </label>
                <div class="form-row">
                  <div class="col-6">
                    <select
                      v-model="$v.form.feeCalcType.$model"
                      :class="['custom-select form-control', { 'is-invalid': $v.form.feeCalcType.$error }]"
                    >
                      <option :value="null">
                        {{ $t('placeholder.select') }}
                      </option>
                      <option :value="FEE_CALC_TYPE.NET">
                        {{ $t('apps.product.message.calctypenet') }}
                      </option>
                      <option :value="FEE_CALC_TYPE.CUSTOM">
                        {{ $t('apps.product.message.calctypecustom') }}
                      </option>
                    </select>
                  </div>
                  <div
                    v-if="form.feeCalcType === FEE_CALC_TYPE.CUSTOM"
                    class="col-6">
                    <select
                      v-model="$v.form.feeCalcTaxId.$model"
                      :class="['custom-select form-control', { 'is-invalid': $v.form.feeCalcTaxId.$error }]"
                    >
                      <option :value="null">
                        {{ $t('placeholder.select') }}
                      </option>
                      <option
                        v-for="(tax, index) in taxesNames"
                        :key="index"
                        :value="tax.id"
                      >
                        {{ tax.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="mt-3">
          <div class="row">
            <div class="col-12">
              <section-header :title="$t('apps.product.message.advancedoptions')"/>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <label>
                {{ $t('apps.product.message.group') }}
              </label>
              <div class="form-row">
                <div class="col-lg-6">
                  <vue-bootstrap-autocomplete
                    v-model="form.groupName"
                    :data="getTaxesGroupNames"
                    :minMatchingChars="1"
                    :showOnFocus="true"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 mt-2">
              <BaseCheckbox
                v-model="form.isForSale"
                :disabled="true"
                :label="$t('apps.product.message.taxforsale')"
              />
            </div>
            <div
              v-if="[TAX_FORM_TYPE.TAX].includes(form.formType)"
              class="col-12 mt-2">
              <BaseCheckbox
                v-model="form.isForPurchase"
                :label="$t('apps.product.message.taxforpurchase')"
              />
            </div>
            <div
              v-if="[TAX_FORM_TYPE.TAX].includes(form.formType)"
              class="col-12 mt-2">
              <BaseCheckbox
                v-model="form.isForExpense"
                :label="$t('apps.product.message.taxforexpense')"
              />
            </div>
            <!-- <div
              v-if="[TAX_FORM_TYPE.TAX].includes(form.formType)"
              class="col-12 mt-2">
              <BaseCheckbox
                v-model="form.isForPayroll"
                :label="$t('apps.product.message.taxforpayroll')"
              />
            </div> -->
            <div
              v-if="[TAX_FORM_TYPE.FEE].includes(form.formType)"
              class="col-12 mt-2">
              <BaseCheckbox
                v-model="form.isDisplayResult"
                :label="$t('apps.product.message.showfeeresult')"
              />
            </div>
          </div>
        </section>

        <section
          class="assign-items mt-3"
          style="margin-bottom: 20px;">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.assignitems')"/>
            <BaseNotFoundData
              v-if="!products.length"
              :title="$t('apps.pos.message.notfoundproduct')"
              :detail="$t('apps.pos.message.createproduct')"
            />
            <base-assign-items
              v-else
              v-model="form.assignProductIds"
              :items="form.assignProductItems"
            />
          </div>
        </section>

        <section class="mt-4">
          <div class="row">
            <div
              class="col-12 mt-2">
              <BaseCheckbox
                v-model="form.isActive"
                :label="form.isActive ? $t('message.enabled') : $t('message.disabled')"
              />
            </div>
          </div>
        </section>

        <section class="mt-4">
          <div class="col-md-12 no-padding">
            {{ $t('message.applyitemtoapps', {item: $t('sidebar.taxes')}) }}
            <a
              href="https://www.treesoft.io/th/manual/product#tax"
              target="_blank">
              {{ $t('button.learnmore') }}
              <i class="fas fa-external-link-alt"/>
            </a>
          </div>
        </section>

        <section class="action-bar">
          <div
            v-if="!$store.state.app.loading"
            class="col-md-12 text-right">
            <button
              class="btn btn-web"
              @click="save()">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="col-md-12 text-right">
            <button
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </section>
      </template>

    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import { TAX_FORM_TYPE, FEE_CALC_TYPE } from '@/helpers/enum'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'TaxNew',
  mixins: [discardFormMixin],
  data () {
    return {
      TAX_FORM_TYPE,
      FEE_CALC_TYPE,

      ready: false,

      form: {
        formType: TAX_FORM_TYPE.TAX,
        tax_name: '',
        amount: '0',
        type: 'exclude',
        groupName: null,
        isDisplayResult: false,
        isForSale: true,
        isForPurchase: true,
        isForExpense: false,
        isForPayroll: false,
        isActive: true,
        feeCalcType: null,
        feeCalcTaxId: null,
        assignProductIds: [],
        assignProductItems: [],
      },
    }
  },
  validations: {
    form: {
      tax_name: {
        required,
      },
      feeCalcType: {
        requiredWithCondition: function(value) {
          if (this.form.formType === TAX_FORM_TYPE.FEE) {
            return !!value
          } else {
            return true
          }
        },
      },
      feeCalcTaxId: {
        requiredWithCondition: function(value) {
          if (this.form.formType === TAX_FORM_TYPE.FEE && this.form.feeCalcType === FEE_CALC_TYPE.CUSTOM) {
            return !!value
          } else {
            return true
          }
        },
      },
    },
  },
  computed: Object.assign(mapGetters({
    products: 'getProducts',
    currency: 'getCurrency',
    getTaxesGroupNames: 'getTaxesGroupNames',
    taxes: 'getTaxes',
  }), {
    dataSet () {
      let data = {
        form_type: this.form.formType,
        tax_name: this.form.tax_name,
        type: (() => {
          if (this.form.formType === TAX_FORM_TYPE.TAX) {
            return this.form.type
          }
          return 'exclude'
        })(),
        amount: parseInt(this.form.amount),
        group_name: !this.form.groupName ? null : this.form.groupName,
        is_display_fee_result: (() => {
          if (this.form.formType === TAX_FORM_TYPE.FEE) {
            return this.form.isDisplayResult
          }
          return true
        })(),
        is_for_sale: this.form.isForSale,
        is_for_purchase: (() => {
          if (this.form.formType === TAX_FORM_TYPE.TAX) {
            return this.form.isForPurchase
          }
          return false
        })(),
        is_for_expense: (() => {
          if (this.form.formType === TAX_FORM_TYPE.TAX) {
            return this.form.isForExpense
          }
          return false
        })(),
        is_for_payroll: (() => {
          if (this.form.formType === TAX_FORM_TYPE.TAX) {
            return this.form.isForPayroll
          }
          return false
        })(),
        is_active: this.form.isActive,
      }
      if (this.form.formType === TAX_FORM_TYPE.FEE) {
        data['fee'] = {
          calc_type: this.form.feeCalcType,
          calc_tax_id: (() => {
            if (this.form.feeCalcType === FEE_CALC_TYPE.CUSTOM) {
              return this.form.feeCalcTaxId
            }
            return null
          })(),
        }
      }
      if (this.form.assignProductIds.length > 0) {
        data['assign'] = this.form.assignProductIds.map((id) => {
          return {
            product_id: id,
          }
        })
      }
      return data
    },
    taxesNames() {
      return this.taxes.map((tax) => {
        return {
          id: tax.tax_id,
          name: tax.tax_name,
        }
      })
    },
  }),
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
  },
  created: async function () { // call api to get data and set state
    // get products
    await this.$store.dispatch('getProducts')
    // get taxes
    await this.$store.dispatch('getTaxes')
    // get taxes group names
    await this.$store.dispatch('getTaxesGroupNames')
    // set amount
    this.form.amount = this.setToCustomDigitsNumber(this.form.amount)
    // set data
    this.setData()
    // set ready
    this.ready = true
  },
  beforeMount: function () { // set states ui
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.accounts.title'),
      current: {
        app_name: 'accounts',
        app_id: 12,
        module_id: 8,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 6,
      submenuAtIdx: 1,
    })
  },
  destroyed: function () { // leave this page
    this.leavePage(this.$Progress, ['clearProducts'])
  },
  methods: {
    setData() {
      this.form.assignProductItems = []
      for (const product of this.products) {
        const item = {
          text: product.product_name,
          value: product.product_id,
        }
        this.form.assignProductItems.push(item)
      }
    },
    async save () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return false
      }

      let res = await this.$store.dispatch('insertTax', this.dataSet)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: this.form.tax_name }),
          color: 'success',
          icon: 'cloud',
        })
        // go to GoodsIssueAll page
        return this.$router.push({
          name: 'TaxAll',
          query: {
            ignoreDiscardAlert: true,
          },
        })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/accounts/tax/New.vue